import React from 'react';
import SummaryStatCard from './SummaryStatCard';
import '../Dashboard.css';

function SummaryStrip({ items = [] }) {
  if (!items.length) {
    return null;
  }

  return (
    <div className="summary-strip" aria-label="Dashboard summary">
      {items.map((item) => (
        <SummaryStatCard key={item.label} item={item} />
      ))}
    </div>
  );
}

export default SummaryStrip;
